module.exports = __webpack_public_path__ + "img/7_of_Clubs.svg.f24fa4da.png";